import React from 'react'
import ScrollToTop from '../components/ScrollToTop'
import { Helmet } from 'react-helmet';

function About() {
  return (
    <>
      <ScrollToTop />
      <Helmet>
        <title>За Нас - Вашиот најдобар избор за масла, филтри, делови и адитиви за автомобили</title>
        <meta name="description" content="Запознајте ја нашата компанија и нашите услуги за продажба на автоделови." />
        <meta name="keywords" content="за нас, масла за автомобили, филтри, адитиви, автопродукти, продавница за автоделови" />
      </Helmet>
      <div className='w-full flex justify-center py-16 bg-gray-50 mt-6 '>
        <div className='mx-auto max-w-[800px] px-6 '>
          <h1 className='text-5xl font-semibold text-center'>За нас</h1>
          <p className='text-l mt-6  leading-relaxed'>
            Ние сме тим на ентузијасти, поврзани со една заедничка страст – автомобилите. Свесни сме дека во денешно време, со брзиот начин на живот и ограниченото слободно време, редовното одржување на автомобилите може да биде предизвик.
          </p>
          <p className='text-l mt-6  leading-relaxed'>
            Знаејќи ја важноста на редовната грижа за автомобилите и земајќи ги во предвид нашите искуства и проблеми со кои се имаме сретнато при одржување на нашите автомобили, добивме инспирација да ја создадеме оваа онлајн продавница. Нашата цел е да Ви заштедиме време и да Ви овозможиме најдобро искуство при купувањето на масло и филтри.
          </p>
          <p className='text-l mt-6  leading-relaxed'>
            На нашиот вебсајт на едно место може да најдете сè што Ви е потребно за мал сервис на вашиот автомобил вклучувајќи внимателно избрани моторни масла и филтри за сите автомобили.
          </p>
          <p className='text-l mt-6  leading-relaxed'>
            Придружете ни се на ова патување и дозволете ни да бидеме ваш партнер во редовното одржување на Вашиот автомобил!
          </p>
        </div>
      </div>
    </>

  )
}

export default About
